import { Protocol } from '../Protocol';

export class TypeTransactionProtocol {

  public static readonly TYPE_TRANSACTION: string = `${Protocol.YATUNG_API_ROOT}/type-transaction/all`;  // 取得所有交易類型設定
  public static readonly TYPE_TRANSACTION_URL: string = `${Protocol.YATUNG_API_ROOT}/type-transaction`;  // 修改 && 新增交易類型設定

}
